import baseUrl from "./baseUrl";
const APP_BASE = baseUrl.WEBSITE_URL;
export const SHARE_QR = APP_BASE + "share/";
export const SHARE_QR_NODE = APP_BASE + "qr/";
export const CARD_SHARE = APP_BASE + "share/card/";
export const EMEGENCY_CONTACT_SHARE = APP_BASE + "share/emergencyContact/";
